import { CommingSoon } from "@components"

export const PlaygroundPage = () => {
    return <CommingSoon/>
}